var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"suaw-label",class:[
    'suaw-label--' + _vm.size,
    'suaw-label--' + _vm.weight,
    _vm.className
  ],attrs:{"for":_vm.labelFor},domProps:{"innerHTML":_vm._s(_vm.labelText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }